import { useMemo } from "react";
import BidimencionalChart from "../../../../../Components/apexcharts/BidimencionalChart";
import { IChatComStatus } from "../../../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";

interface IAtendimentosComMaiorAguardoPorParteDoClienteChartProps {
    listaChatsAbertosFirebase: Array<IChatComStatus> | undefined;
}

export default function AtendimentosComMaiorAguardoPorParteDoClienteChart(
    props: IAtendimentosComMaiorAguardoPorParteDoClienteChartProps
) {
    const { listaChatsAbertosFirebase } = props;

    const dadosDoGrafico = useDadosGrafico(listaChatsAbertosFirebase);
    const titleComplement = dadosDoGrafico ? `(em ${dadosDoGrafico.exibicao})` : ""

    return (
        <BidimencionalChart
            options={{
                title: {
                    text: `Atendimentos com maior espera do cliente ${titleComplement}`,
                },
                xaxis: {
                    categories: dadosDoGrafico?.clientes ?? [],
                },
                noData: {
                    text: dadosDoGrafico?.clientes ? "Nenhum registro" : "Carregando",
                },
                plotOptions: {
                    bar: {
                        horizontal: true
                    }
                }
            }}
            type="bar"
            series={[
                {
                    name: `tempo em ${dadosDoGrafico?.exibicao}`,
                    data: dadosDoGrafico?.horas.map(h => Math.round(h)) ?? [], // esse map é para que o número esteja fixo em 2 casas decimais
                },
            ]}
        />
    );
}

function useDadosGrafico(listaChatsAbertosFirebase: Array<IChatComStatus> | undefined) {
    return useMemo(() => {
        if (listaChatsAbertosFirebase) {
            const listaTop10AtendimentosMaiorTempoDeEsperaDoCliente = listaChatsAbertosFirebase
                .filter(a => a.Lido > 0)
                .sort((a, b) => {
                    return getTempoSemResposta(b) - getTempoSemResposta(a) // comparando o timestamp da primeira mensagem
                })
                .slice(0, 10);

            const timestampDiffs = listaTop10AtendimentosMaiorTempoDeEsperaDoCliente.map(getTempoSemResposta);
            const exibicao = timestampDiffs.every(a => (a / 1000 / 60 / 60) < 7) ? 'minutos' : // se só tiver diffs com menos de 7 horas, a exibição é por minutos
                timestampDiffs.every(a => (a / 1000 / 60 / 60 / 24) < 7) ? 'horas' : 'dias'  // se só tiver diffs com menos de 7 dias, a exibição é por horas

            return {
                horas: timestampDiffs.map(a => a / 1000 / 60 / (exibicao !== 'minutos' ? 60 : 1) / (exibicao === 'dias' ? 24 : 1)),
                clientes: listaTop10AtendimentosMaiorTempoDeEsperaDoCliente.map(a => a.NomeCliente || a.ProfileName || a.NumeroCliente.replace("whatsapp:", "")),
                exibicao
            };
        }
        
        return undefined;

    }, [listaChatsAbertosFirebase]);
}

function getTempoSemResposta(chat: IChatComStatus) {
    return Date.now() -
        (chat.conversa?.[
            chat.conversa?.length - chat.Lido
        ]?.TimeStamp || Date.now());
}